import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './components/App/App';
import './index.css';
import i18n from './i18n';

// App script in page will provide the id to mount.
// Taken from https://stackoverflow.com/questions/53562804/how-to-include-the-same-react-app-twice-on-the-same-page
window.mount = function (id) {

  const element = document.getElementById(id);

  const windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'fundhighlightsvars';
  const initParams = {};

  initParams.wtRegion = `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : "US";
  initParams.entityCCY = `${window[windowAppId].entityCCY}` && `${window[windowAppId].entityCCY}` !== 'undefined' ? `${window[windowAppId].entityCCY}` : "USD";
  initParams.tenant = `${window[windowAppId].tenant}` && `${window[windowAppId].tenant}` !== 'undefined' ? `${window[windowAppId].tenant}` : "wisdomtree";
  initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`;
  initParams.dpdApiUrl = `${process.env.REACT_APP_DPD_URL}`;
  initParams.version = `${process.env.REACT_APP_VERSION}` !== 'undefined' ? `${process.env.REACT_APP_VERSION}` : 'DEV';
  initParams.isoCode = `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ? `${window[windowAppId].isoCode}` : "en-US";

  // Change the language to that specified in the page.
  i18n.changeLanguage(initParams.isoCode);

  // Get the tickers we want to show, and frame data if necessary
  initParams.tickers = element.dataset.tickers ? element.dataset.tickers : '';
  initParams.perfTickerToolips = element.dataset.perftickertoolips ? JSON.parse(element.dataset.perftickertoolips) : {};
  initParams.showPerfFootnote = element.dataset.showperffootnote && element.dataset.showperffootnote === 'true' ? true : false;
  initParams.appendPerfFootnote = element.dataset.appendperffootnote ? element.dataset.appendperffootnote : '';
  initParams.showHighlightCard = element.dataset.showhighlightcard && element.dataset.showhighlightcard === 'true' ? true : false;
  initParams.frameBigText = element.dataset.framebigtext ? element.dataset.framebigtext : '';
  initParams.frameTitle = element.dataset.frametitle ? element.dataset.frametitle : '';
  initParams.frameText = element.dataset.frametext ? element.dataset.frametext : '';
  initParams.frameLinkText = element.dataset.framelinktext ? element.dataset.framelinktext : '';
  initParams.frameLink = element.dataset.framelink ? element.dataset.framelink : '';
  initParams.frameLinkText2 = element.dataset.framelinktext2 ? element.dataset.framelinktext2 : '';
  initParams.frameLink2 = element.dataset.framelink2 ? element.dataset.framelink2 : '';
  initParams.sidePadding = element.dataset.sidepadding ? parseInt(element.dataset.sidepadding, 10) : 90;

  // Hide the cumulative returns columns of performance - shown by default
  initParams.hideCumulativeReturns = element.dataset.hidecumulativereturns && element.dataset.hidecumulativereturns === 'true' ? true : false;

  // whether to show since inception and common period in performance table
  initParams.showCommonPeriod = element.dataset.showcommonperiod && element.dataset.showcommonperiod === 'false' ? false : true;
  initParams.showSinceInception = element.dataset.showsinceinception && element.dataset.showsinceinception === 'true' ? true : false;

  // Remove 'WisdomTree' from fund names and update columns in Performance table (e.g., show 'Since Fund Inception' instead of 'Common Period')
  initParams.wtFundsOnly = element.dataset.wtfundsonly && element.dataset.wtfundsonly === 'true' ? true : false;

  // should we show ESG as the main rating
  initParams.esgMode = element.dataset.esgmode && element.dataset.esgmode === 'true' ? true : false;

  // render
  ReactDOM.render((

    <BrowserRouter>
      <App dataProps={element.dataset} params={initParams} />
    </BrowserRouter>

  ),
    element);
}
